import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { IDatasourceActions } from '../../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../../ts/ServerApi/types/IWorkbookActions';
import { deleteExtractRefresh } from '../../../actions/spaces/DeleteExtractRefreshAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { hasExtractRefreshPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const DeleteExtractRefreshEntityAction:
    IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksDelete,
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions);
}
